import React, { useEffect, useState } from 'react';
import Header from './Header';
import Navbar from './Navbar';
import useWindowWidth from '../hooks/useWindowWidth';
interface ILayoutProps {
  children: React.ReactNode;
}
function Layout({ children }: ILayoutProps) {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    const storedState =
      typeof window !== 'undefined' ? localStorage.getItem('navbarCollapsed') : null;
    return storedState ? JSON.parse(storedState) : false;
  });

  const windowWidth = useWindowWidth();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const collapsed = windowWidth < 1280;
    localStorage.setItem('navbarCollapsed', JSON.stringify(collapsed));
    setIsCollapsed(collapsed);
  }, [windowWidth]);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const storedState = localStorage.getItem('navbarCollapsed');
    if (storedState !== null) {
      setIsCollapsed(JSON.parse(storedState));
    }
  }, []);

  const toggleNavbar = () => {
    const newState = !isCollapsed;
    setIsCollapsed(newState);
    if (typeof window !== 'undefined') {
      localStorage.setItem('navbarCollapsed', JSON.stringify(newState));
    }
  };

  return (
    <>
      <div
        style={{
          padding: '0.5rem',
        }}
      >
        <Header />
      </div>
      <div className="layout-container">
        <div className={`navbar-container ${isCollapsed ? 'collapsed' : ''}`}>
          <Navbar isCollapsed={isCollapsed} toggleNavbar={toggleNavbar} />
        </div>
        <div className="component-container">{children}</div>
      </div>
    </>
  );
}

export default Layout;
